import { CircularProgress } from "@mui/material";

export default function NoData({ isLoading = false }) {
  if (isLoading) {
    return (
      <div className="flex h-40 items-center justify-center">
        <CircularProgress size={24} />
      </div>
    );
  }
  return (
    <div className="mb-4 w-full rounded-lg bg-gray-100 p-1 text-center text-xs capitalize text-gray-600">
      No items to show
    </div>
  );
}
